import React, { lazy, Suspense } from "react";
import { Redirect, Route, Switch } from 'react-router-dom';
import Loading from 'components/shared-components/Loading';

const Apps = ({ match }) => (
  <Suspense fallback={<Loading cover="content"/>}>
    <Switch>
      <Route path={`${match.url}/portal-contratos/certificados`} component={lazy(() => import(`./certificados`))} />
      {/* <Route path={`${match.url}/portal-admin/roles`} component={lazy(() => import(`./roles`))} /> */}
      <Route path={`${match.url}/portal-contratos/contratos`} component={lazy(() => import(`./contratos`))} />
      <Route path={`${match.url}/portal-contratos/usuarios`} component={lazy(() => import(`./usuarios`))} />
      <Redirect from={`${match.url}`} to={`${match.url}/portal-contratos/contratos`} />
    </Switch>
  </Suspense>
);

export default Apps;